import { onScopeDispose, reactive, shallowRef } from "vue";

import type { DraftBulkAction } from "@/components/bulk-actions/types";
import { defineStore } from "@/lib/depot";

export const useStore = defineStore("new-bulk-actions", () => {
  const draft = shallowRef<DraftBulkAction>();

  const closeListeners: (() => void)[] = [];
  const doneListeners: (() => void)[] = [];

  return reactive({
    setDraft: (next: DraftBulkAction) => {
      draft.value = next;
    },

    _draft: draft,
    _closeWatchers: closeListeners,
    _doneWatchers: doneListeners,
  });
});

/** @knipignore Not used for now but useful later. */
export const onBulkActionCancel = (listener: () => void) => {
  const store = useStore();

  onScopeDispose(() => {
    store._closeWatchers = store._closeWatchers.filter((fn) => fn !== listener);
  });

  store._closeWatchers.push(listener);
};

export const onBulkActionSuccess = (listener: () => void) => {
  const store = useStore();

  onScopeDispose(() => {
    store._doneWatchers = store._doneWatchers.filter((fn) => fn !== listener);
  });

  store._doneWatchers.push(listener);
};
